import React, { useState } from "react";

// Use environment variable for API target
// For CRA: prefix must be REACT_APP_
// For Vite: prefix must be VITE_
const API_ROOT =
  process.env.REACT_APP_API_TARGET ||
  process.env.VITE_API_TARGET ||
  process.env.API_TARGET ||
  "https://api.wheresglutenfree.com/api";

const API_BASE = `${API_ROOT}/v1`;

export default function RestaurantPhoto({ placeId, photoUrl, maxWidth = 480, height=123, name }) {
  const [errored, setErrored] = useState(false);

  // Prefer explicit photoUrl if provided; otherwise build from API_BASE
  const src =
    photoUrl ||
    (placeId
      ? `${API_BASE}/photos/${encodeURIComponent(placeId)}?maxWidth=${encodeURIComponent(
          maxWidth
        )}`
      : null);

  const Placeholder = () => (
    <div
      className="r-photo placeholder flex flex-col items-center justify-center bg-gray-100 text-gray-400 text-xs rounded-md border border-gray-200 w-full"
      style={{ maxWidth, height, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}
      aria-label="Photo not available"
      role="img"
    >
      <div className="primary-type" style={{ 
        marginTop: 'auto', marginBottom: 'auto', 
        fontSize: 14, width: '100%', textAlign: 'center'}}
      >
        Photo not available
      </div>
    </div>
  );

  // No URL or image broke → show placeholder
  if (!src || errored) return <Placeholder />;

  return (
    <img
      src={src}
      alt={name ? `${name} — photo` : "Restaurant photo"}
      loading="lazy"
      className="r-photo"
      onError={() => setErrored(true)}
    />
  );
}
